/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for HPaymentController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { HPaymentDto, RequestOptions, PaymentResponseDto, HCustomerSubscriptionDto, Pageable, PagedModelHousingPayment } from "../models";

@Injectable({ providedIn: "root" })
export class HPaymentControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    initiateHousingPayment(hPaymentDto: HPaymentDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    initiateHousingPayment(hPaymentDto: HPaymentDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    initiateHousingPayment(hPaymentDto: HPaymentDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    initiateHousingPayment(hPaymentDto: HPaymentDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/housing/payments`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: hPaymentDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getSubscriptionByCustomerPhone(phone: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<HCustomerSubscriptionDto>;
    getSubscriptionByCustomerPhone(phone: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<HCustomerSubscriptionDto>>;
    getSubscriptionByCustomerPhone(phone: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<HCustomerSubscriptionDto>>;
    getSubscriptionByCustomerPhone(phone: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/housing/payments/subscriptions/customer/${phone}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getPaymentsBySubscription(subscriptionId: number, pageable: Pageable, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelHousingPayment>;
    getPaymentsBySubscription(subscriptionId: number, pageable: Pageable, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelHousingPayment>>;
    getPaymentsBySubscription(subscriptionId: number, pageable: Pageable, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelHousingPayment>>;
    getPaymentsBySubscription(subscriptionId: number, pageable: Pageable, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/housing/payments/subscription/${subscriptionId}`;

        let params = new HttpParams();
        if (pageable != null) {
            params = HttpParamsBuilder.addToHttpParams(params, pageable, 'pageable');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
